import { render, staticRenderFns } from "./SettlementPreview.vue?vue&type=template&id=c208d8ea&scoped=true"
import script from "./SettlementPreview.vue?vue&type=script&lang=js"
export * from "./SettlementPreview.vue?vue&type=script&lang=js"
import style0 from "./SettlementPreview.vue?vue&type=style&index=0&id=c208d8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c208d8ea",
  null
  
)

export default component.exports